import React, { useRef, useState, useEffect } from 'react';
import { pdfjs, Document, Page } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url
).toString();

const options = {
    cMapUrl: '/cmaps/',
    standardFontDataUrl: '/standard_fonts/',
    wasmUrl: '/wasm/',
};

const PDFViewer = ({ setTotalSlides, currentSlide, file, setOutline }) => {
    const containerRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(800);
    const [loading, setLoading] = useState(true);

    const onDocumentLoadSuccess = async (pdf) => {
        setTotalSlides(pdf.numPages);
        const outline = await pdf.getOutline();

        if (outline && setOutline) {
            setOutline(outline);
        }

        setLoading(false);
    };

    const onDocumentLoadStart = () => {
        setLoading(true);
    };

    const onDocumentLoadError = () => {
        setLoading(false);
    };

    // ResizeObserver to track container width
    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                if (entry.contentRect) {
                    setContainerWidth(entry.contentRect.width);
                }
            }
        });

        if (containerRef.current) {
            resizeObserver.observe(containerRef.current);
        }

        return () => resizeObserver.disconnect();
    }, []);

    return (
        <div className="flex flex-col items-center justify-center w-full h-full p-8">
            <div ref={containerRef} className="relative w-full max-w-5xl">
                {loading && (
                    <div className="absolute inset-0 z-10 flex items-center justify-center bg-white bg-opacity-70">
                        <span className="text-sm text-gray-600">Loading...</span>
                    </div>
                )}
                <Document
                    file={file}
                    onLoadStart={onDocumentLoadStart}
                    onLoadSuccess={onDocumentLoadSuccess}
                    onLoadError={onDocumentLoadError}
                    options={options}
                >
                    <Page
                        pageNumber={currentSlide}
                        width={containerWidth}
                    />
                </Document>
            </div>
        </div>
    );
};

export default PDFViewer;
